import { render, staticRenderFns } from "./keyboard-dialog.vue?vue&type=template&id=43ebeb31&scoped=true"
import script from "./keyboard-dialog.vue?vue&type=script&lang=js"
export * from "./keyboard-dialog.vue?vue&type=script&lang=js"
import style0 from "./keyboard-dialog.vue?vue&type=style&index=0&id=43ebeb31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ebeb31",
  null
  
)

export default component.exports